import { twMerge } from "tailwind-merge";
import React from "react";

// Remove TypeScript types and annotations for JS compatibility

const VARIANTS = {
  primary: "bg-[#004175] text-white hover:bg-[#00325d]",
  outline:
    "bg-transparent text-[#004175] border border-[#004175] hover:bg-[#e6f0f8]",
  ghost: "bg-transparent text-[#004175] hover:bg-gray-100",
};

function Button({
  type = "button",
  disabled = false,
  loading = false,
  children,
  onClick,
  className = "",
  variant = "primary",
}) {
  const baseClasses = "w-full py-2 px-4 rounded-md transition cursor-pointer";
  const disabledClasses = "opacity-50 cursor-not-allowed";
  const variantClass = VARIANTS[variant] || VARIANTS.primary;

  const mergedClassName = twMerge(
    baseClasses,
    variantClass,
    (disabled || loading) && disabledClasses,
    className
  );

  return (
    <button
      style={{border: "1px solid"}}
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={mergedClassName}
    >
      {loading ? "Loading..." : children}
    </button>
  );
}

export default Button;
